<template>
  <van-popup class="shall-buy-popup" v-model="isShow" :close-on-click-overlay="closeclick" @touchmove.native.stop.prevent>
    <div class="box">
      <img src="../../../assets/common/BG@2x.png" alt v-if="!titleText"/>
      <p class="title" v-if="titleText">{{ titleText }}</p>
      <p class="tips">{{tipMessage}}</p>
      <!-- <span class="left" @click="cancleTip()">取消</span> -->
      <span class="right" @click="confirm()">确定</span>
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      show: true
    };
  },
  props: {
    closeclick: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      required: true
    },
    titleText: {
      type: String,
      default: "温馨提示"
    },
    tipMessage: {
      type: String,
      default: ""
    },
  },
  created() {},
  mounted() {},
  methods: {
    confirm(){
      this.$emit('popupConfirm')
    },
  },
};
</script>

<style lang="less">
.shall-buy-popup {
  width: 70%;
  border-radius: 10px;
  .box {
    text-align: center;
    img {
      display: block;
      width: 100%;
    }
    .title {
      color: #333;
      font-size: 15px;
      font-weight: 600;
      line-height: 47px;
      margin-top: 8px;
      text-align: center;
    }
    .tips {
      color: #333;
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      margin-bottom: 30px;
      padding: 0 10px;
    }
    span {
      // float: left;
      width: 50%;
      border-top: solid 1px #f2f2f2;
      line-height: 43px;
      color: #999;
      font-size: 14px;
      text-align: center;
      display: inline-block;
    }
    .right {
      color: #e6212f;
      width: calc(50% - 1px);
      border: solid 1px #f2f2f2;
      margin-bottom: 6px;
    }
  }
}
</style>
